(function(){
    'use strict';

    angular
    .module('appback')
    .controller('FavoritasController', FavoritasController)
 
    FavoritasController.$inject = ["FavoritasService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function FavoritasController(FavoritasService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
		vm.generalLab = GenerallabService;
		vm.filros = {};
		vm.total = {};
		
    	vm.marcar = function(peticion_id,analitica_id){
    		vm.filtros = {peticion_id:peticion_id,analitica_id:analitica_id};
    		FavoritasService.marcar(vm.filtros,function(data){
    			if(!angular.isDefined[peticion_id]){
    				vm.total[peticion_id] = {};
    			}
    			$timeout(function(){
    				vm.total[peticion_id][analitica_id] = true;
    			})
    			//console.log(vm.total);
	        })
    	}


    }
  
})();